import { AlphabetizedMap } from '../utils/EntityMap';

let { _,x,b,c,d,e,f,g,h,i,j,k,l,m } = AlphabetizedMap;
/* 
    b=flame=red
    c=N=blue
    d=coin=green
    e=star=yellow
    f=solidBlack=purple
    g=moon=skyBlue
    h=heart=orange
    i=triangle=pink
    j=blank=white
    k=grey=grey
    l=special=rainbow
    m=block=gold
*/

export default [
    [h,0,0,0,0,m,m,h,h,h,m,m,0,0,0,0,h],
     [f,i,b,e,0,m,h,h,h,h,m,0,e,b,i,f,_],
    [0,0,0,0,k,0,h,0,0,0,h,0,k,0,0,0,0],
     [0,i,f,h,0,f,i,b,e,k,h,0,h,f,i,0,_],
    [0,b,0,0,0,i,0,0,0,0,0,f,0,0,0,b,0],
     [0,e,k,h,f,0,0,0,0,0,0,k,h,k,e,0,_],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
     [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,_],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
     [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,_],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
     [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,_],
    [x,x,x,x,x,x,x,x,x,x,x,x,x,x,x,x,x]
];